'use strict';

module.exports = function isNegativeZero(x) {
	return x === 0 && 1 / x === 1 / -0;
};
